module.exports = __webpack_public_path__ + "static/media/CM pragati yatra.d375cc9a.svg";